import { Icon } from '../../icon';

export class DataFlowAction {
  public Action: string;

  public Disabled?: boolean;

  public Icon?: Icon;

  public Order?: number;

  public Text: string;
}
